export class FavoriteListNotFoundError extends Error {
  constructor(public favoriteListId: string) {
    super(`Favorite list with id ${favoriteListId} not found.`)
  }
}
